import {
  IconCrown,
  IconUserStar,
  IconUserCheck,
  IconEye,
  IconUser,
} from "@tabler/icons-react";
import { ROLE_BADGE_CONFIG } from "./data";
import styles from "./RoleBadge.module.css";

const ICONS = {
  crown: IconCrown,
  userStar: IconUserStar,
  userCheck: IconUserCheck,
  eye: IconEye,
};

export default function RoleBadge({ role, size = 13 }) {
  const config = ROLE_BADGE_CONFIG[role];
  const Icon = (config && ICONS[config.icon]) || IconUser;
  const cls = config ? styles[config.key] : styles.viewer;

  return (
    <span className={`${styles.badge} ${cls}`}>
      <Icon size={size} />
      {role}
    </span>
  );
}
